var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { styled } from '@material-ui/core/styles';
import { Button as _Button, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@material-ui/core';
import ExitToApp from '@material-ui/icons/ExitToApp';
import Settings from '@material-ui/icons/Settings';
import { Component } from 'react';
import React from 'react';
import AvatarWithName from './AvatarWithName';
import { SPACING_UNIT, SPACING_LARGE } from '../constant/spacing';
var initialState = {
    open: false,
    anchorEl: undefined,
};
var UserMenu = /** @class */ (function (_super) {
    __extends(UserMenu, _super);
    function UserMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        _this.onClickMenu = function (e) {
            _this.setState({ open: true, anchorEl: e.currentTarget });
        };
        _this.onRequestClose = function () {
            _this.setState({ open: false });
        };
        _this.onClickAccountSettings = function () {
            _this.props.onClickAccountSettings();
            _this.setState({ open: false });
        };
        _this.onClickSignOut = function () {
            _this.props.onClickSignOut();
            _this.setState({ open: false });
        };
        return _this;
    }
    UserMenu.prototype.render = function () {
        var _a = this.props, user = _a.user, className = _a.className;
        return (React.createElement(Root, { className: className },
            React.createElement(Button, { size: "small", onClick: this.onClickMenu },
                React.createElement(AvatarWithName, { imageUrl: user ? user.profileImageUrl : undefined, name: user ? user.username || '' : '', "aria-owns": this.state.open ? 'menu-appbar' : null, "aria-haspopup": "true" })),
            React.createElement(StyledMenu, { id: "menu-appbar", anchorEl: this.state.anchorEl, anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                }, open: this.state.open, onClose: this.onRequestClose },
                React.createElement(MenuItem, { button: true, onClick: this.onClickAccountSettings },
                    React.createElement(ListItemIcon, null,
                        React.createElement(Settings, null)),
                    React.createElement(ListItemText, { primary: React.createElement(Typography, null, "\u30A2\u30AB\u30A6\u30F3\u30C8\u8A2D\u5B9A") })),
                React.createElement(MenuItem, { button: true, onClick: this.onClickSignOut },
                    React.createElement(ListItemIcon, null,
                        React.createElement(ExitToApp, null)),
                    React.createElement(ListItemText, { primary: React.createElement(Typography, null, "\u30ED\u30B0\u30A2\u30A6\u30C8") })))));
    };
    return UserMenu;
}(Component));
var Root = styled('div')({});
var Button = styled(_Button)({
    padding: SPACING_UNIT / 2,
    textTransform: 'none',
});
var StyledMenu = styled(Menu)({
    marginTop: SPACING_LARGE,
});
export default UserMenu;
